(function () {

    "use strict";
    function basicFormController() {

    }

    basicFormController.$inject = [];

    angular.module("sphforms.main")
        .component("sphformsBasicForm", {
            transclude: true,
            controller: basicFormController,
            templateUrl: "modules/main/components/basicForm/basicForm.template.html"
        });

}());
